/**
 * Husleie.no API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0
 * Contact: devops+api@husleie.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import DefaultErrorResponseScheme from '../model/DefaultErrorResponseScheme';
import InlineObject9 from '../model/InlineObject9';
import InlineResponse20012 from '../model/InlineResponse20012';

/**
 * RentalObject service.
 * @module api/RentalObjectApi
 * @version 1.0
 */
export default class RentalObjectApi {

    /**
     * Constructs a new RentalObjectApi. 
     * @alias module:api/RentalObjectApi
     * @class
     * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
     * default to {@link module:ApiClient#instance} if unspecified.
     */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the getRentalObject operation.
     * @callback module:api/RentalObjectApi~getRentalObjectCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse20012} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a specific rental objects and attached tenancies
     * This should return a specific rental object
     * @param {Number} landlordId 
     * @param {Number} rentalObjectId 
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/String>} opts.tenancyStatus Which status of the tenancies should be listed
     * @param {Boolean} opts.extended Return extended information about the rental object (default to false)
     * @param {module:api/RentalObjectApi~getRentalObjectCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse20012}
     */
    getRentalObject(landlordId, rentalObjectId, opts, callback) {
        opts = opts || {};
        let postBody = null;

        // verify the required parameter 'landlordId' is set
        if (landlordId === undefined || landlordId === null) {
            throw new Error("Missing the required parameter 'landlordId' when calling getRentalObject");
        }

        // verify the required parameter 'rentalObjectId' is set
        if (rentalObjectId === undefined || rentalObjectId === null) {
            throw new Error("Missing the required parameter 'rentalObjectId' when calling getRentalObject");
        }


        let pathParams = {
            'landlord_id': landlordId,
            'rental_object_id': rentalObjectId
        };
        let queryParams = {
            'tenancyStatus': this.apiClient.buildCollectionParam(opts['tenancyStatus'], 'csv'),
            'extended': opts['extended']
        };
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse20012;

        return this.apiClient.callApi(
            '/landlord/{landlord_id}/rental_object/{rental_object_id}', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the patchRentalObject operation.
     * @callback module:api/RentalObjectApi~patchRentalObjectCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update content of a rental object
     * This accepts a full or partial update of a rental object.
     * @param {Number} landlordId 
     * @param {Number} rentalObjectId 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject9} opts.rentalObject 
     * @param {module:api/RentalObjectApi~patchRentalObjectCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patchRentalObject(landlordId, rentalObjectId, opts, callback) {
        opts = opts || {};
        let postBody = opts['rentalObject'];

        // verify the required parameter 'landlordId' is set
        if (landlordId === undefined || landlordId === null) {
            throw new Error("Missing the required parameter 'landlordId' when calling patchRentalObject");
        }

        // verify the required parameter 'rentalObjectId' is set
        if (rentalObjectId === undefined || rentalObjectId === null) {
            throw new Error("Missing the required parameter 'rentalObjectId' when calling patchRentalObject");
        }


        let pathParams = {
            'landlord_id': landlordId,
            'rental_object_id': rentalObjectId
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = null;

        return this.apiClient.callApi(
            '/landlord/{landlord_id}/rental_object/{rental_object_id}', 'PATCH',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }


}